__turbopack_context__.v({
  "className": "dm_mono_f3590726-module__Boz4Za__className",
  "variable": "dm_mono_f3590726-module__Boz4Za__variable",
});
